import { useTranslation } from 'react-i18next';
const labels = {
    "agenda.scope": "Vista da agenda",
    "agenda.mine": "Minha agenda",
    "agenda.clinic": "Agenda da clínica",
    "agenda.create": "Novo agendamento",
    "agenda.created": "Agendamento criado.",
    "agenda.dateTime": "Data e hora",
    "agenda.futureTime": "Selecione uma data e hora futuras.",
    "agenda.validDuration": "Introduza uma duração inteira superior a zero.",
    "agenda.patientsError": "Não foi possível carregar os pacientes.",
    "agenda.doctorsError": "Não foi possível carregar os médicos.",
    "agenda.noPatients": "Sem pacientes para esta pesquisa.",
    "agenda.noDoctors": "Sem médicos disponíveis.",
    "agenda.morePatients": "Carregar mais pacientes",
    "agenda.loading": "A carregar...",
    "agenda.search": "Pesquisar paciente...",
    "agenda.clinicians": "Todos os clínicos",
    "agenda.status": "Estado",
    "agenda.scheduledOngoing": "Agendados e em curso",
    "agenda.date": "Data",
    "agenda.time": "Hora",
    "agenda.patient": "Paciente",
    "agenda.clinician": "Clínico",
    "agenda.actions": "Ações",
    "agenda.calendar": "Calendário",
    "agenda.today": "Hoje",
    "agenda.apply": "Aplicar",
    "agenda.rangeError": "Selecione um período igual ou inferior a 7 dias.",
    "agenda.summary": "Resumo",
    "agenda.total": "Total de agendamentos",
    "agenda.scheduled": "Agendados",
    "agenda.ongoing": "Em curso",
    "agenda.completed": "Concluídos",
    "agenda.cancelled": "Cancelados",
    "agenda.stateScheduled": "Agendado",
    "agenda.stateOngoing": "Em curso",
    "agenda.stateCompleted": "Concluído",
    "agenda.stateCancelled": "Cancelado",
    "agenda.appointmentList": "Lista de agendamentos",
    "agenda.loadError": "Não foi possível carregar os agendamentos.",
    "agenda.cliniciansError": "Não foi possível carregar os clínicos. A lista continua a mostrar todos os clínicos.",
    "agenda.empty": "Sem agendamentos para os filtros selecionados.",
    "agenda.retry": "Tentar novamente",
    "agenda.addNote": "Adicionar nota",
    "agenda.viewNote": "Ver nota",
    "agenda.noteContent": "Nota do agendamento",
    "agenda.noteLoadError": "Não foi possível carregar a nota.",
    "agenda.notesUnavailable": "Notas disponíveis apenas para clínicos.",
    "agenda.reschedule": "Reagendar",
    "agenda.rescheduleScheduledOnly": "Só é possível reagendar consultas no estado Agendado.",
    "agenda.rescheduleExplanation": "O agendamento atual será cancelado e será criado um novo para o mesmo paciente e clínico. As notas permanecem no registo original.",
    "agenda.originalCancelled": "O agendamento original já foi cancelado.",
    "agenda.reschedulePartialError": "O original foi cancelado, mas não foi possível confirmar a criação do novo. Verifique a agenda antes de repetir para evitar duplicados.",
    "agenda.verifiedNotCreated": "Verifiquei que o novo agendamento não foi criado.",
    "agenda.newTime": "Nova data e hora",
    "agenda.duration": "Duração (minutos)",
    "agenda.invalidReschedule": "Escolha uma nova data.",
    "agenda.manageStatus": "Gerir estado",
    "agenda.markScheduled": "Marcar como agendado",
    "agenda.markOngoing": "Marcar como em curso",
    "agenda.markCompleted": "Marcar como concluído",
    "agenda.markCancelled": "Marcar como cancelado",
    "agenda.actualStart": "Início efetivo",
    "agenda.actualEnd": "Fim efetivo",
    "agenda.invalidTime": "Introduza uma data válida. O fim não pode ser anterior ao início.",
    "agenda.saveError": "Não foi possível guardar. Verifique o estado atual antes de tentar novamente.",
    "agenda.save": "Guardar",
    "agenda.cancel": "Cancelar",
    "agenda.close": "Fechar"
};
export const useAgendaTranslation = () => {
    const { i18n } = useTranslation();
    return { i18n, t: (key, options) => i18n.t(labels[key] || key, options) };
};
